module.exports = __webpack_public_path__ + "img/header-pacman.8ee84034.svg";